import { Factory } from "@/repository/Factory";
const RFQ = Factory.get("rfq");

const state = {
  rfqs: [],
  dealers: [],
  project_rfqs: []
};

const actions = {
  // List Dealer RFQs
  async getDealerRFQ({ commit }, payload) {
    commit("setRFQs", []);
    return await RFQ.getDealerRFQ(payload).then(
      response => {
        if (response.status === 200) {
          commit("setRFQs", response.data);
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // List RFQ Project Details
  async getDealerRFQDetails({ commit }, payload) {
    return await RFQ.getDealerRFQDetails(payload).then(
      response => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Decline RFQ
  async declineRFQ({ commit }, payload) {
    return await RFQ.declineRFQ(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: "RFQ for project declined successfully",
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  getDealerContacts({ commit }, payload) {
    commit("setContacts", []);
    return RFQ.getDealerContacts(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit("setContacts", response.data.dealers);
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // List Dealer RFQs
  async getProjectRFQs({ commit }, payload) {
    commit("setProjectRFQs", []);
    return await RFQ.getProjectRFQs(payload).then(
      response => {
        if (response.status === 200) {
          commit("setProjectRFQs", response.data.RFQ);
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  async getDealerRFQById({ commit }, payload) {
    return await RFQ.getDealerRFQById(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Send RFQ
  async sendRFQ({ commit }, payload) {
    return await RFQ.sendRFQ(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Send Quote
  async sendDealerQuote({ commit }, payload) {
    return await RFQ.sendDealerQuote(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message || "Quote sent successfully",
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Accept RFQ Bid
  async acceptBid({ commit }, payload) {
    return await RFQ.acceptBid(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          // commit("setRFQAwarded", payload.id);
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  }
};

const mutations = {
  setRFQs(state, rfqs) {
    state.rfqs = JSON.parse(JSON.stringify(rfqs));
  },
  setProjectRFQs(state, rfqs) {
    state.project_rfqs = JSON.parse(JSON.stringify(rfqs));
  },
  setRFQAwarded(state, payload) {
    const rfq = state.project_rfqs.find((quote, index) => {
      if (quote.id === payload) {
        return {
          id: quote.id,
          index
        };
      }
    });

    if (rfq && rfq.id) {
      state.project_rfqs[rfq.index].status = "awarded";
    }
  },
  setContacts(state, dealers) {
    state.dealers = JSON.parse(JSON.stringify(dealers));
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
